import React from 'react';

//  Headers
import { AffiliateHeader } from '../AffiliateHeader';
import { Header } from '../Header';
import { Navbar } from '../Navbar';

// Heroes
import { FeaturedBlogPost } from '../BlogComponents/FeaturedPost';
import { FullwidthHero } from '../FullwidthHero';
import { HomepageHero } from '../HomepageHero';
import { OverlayHero } from '../OverlayHero';
import { PerformanceHero } from '../PerformanceHero';
import { StackedHero } from '../StackedHero';
import { TextOnlyHero } from '../TextOnlyHero';

// Footers
import { Footer } from '../Footer/1.0';
import { Footer2 } from '../Footer/2.0';
import { FinalCallout } from '../FinalCallout';

// Banners
import { WebBanner } from '../WebBanner';
import { TopSpacer } from '../TopSpacer';

// Page Blocks
import { AsFeaturedOn } from '../AsFeaturedOn';
import { AssetWith5050Text } from '../AssetWith5050Text';
import { BadgeList } from '../BadgeList';
import { BodyCopy } from '../BodyCopy';
import { CareersBlock } from '../CareersBlock';
import { CollapsiblePlansList } from '../CollapsiblePlansList';
import { ImageWith5050Text } from '../ImageWith5050Text';
import { ImageWith7030Text } from '../ImageWith7030Text';
import { InfoBlock } from '../InfoBlock';
import { Milestone } from '../Milestone';
import { PlansList } from '../PlansList';
import { PlansTable } from '../PlansTable';
import { PressList } from '../PressList';
import { SectionWithCollapsibles } from '../SectionWithCollapsibles';
import { SectionWithPagePointers } from '../SectionWithPagePointers';
import { SocialProof } from '../SocialProof';
import { SplitModule } from '../SplitModule';
import { Storytelling } from '../Storytelling';
import { Tables } from '../Tables';
import { TestimonialSliderBlock } from '../TestimonialSliderBlock';
import { VideoBlock } from '../VideoBlock';
import { VideoBlockFullWidth } from '../VideoBlockFullWidth';
import { VideoWith5050Text } from '../VideoWith5050Text';

// Split Modules
import { Form as SplitForm } from '../SplitModule/Form';
import { AssetWithText as SplitAssetWithText } from '../SplitModule/AssetWithText';

import { StyledVariation } from './styles';

export interface VariationProps {
  className?: string;
  isActive?: boolean;
}

export function Variation({ pageBlock, className, isActive }: any) {
  const { sys, fields } = pageBlock ?? {};

  return (
    <StyledVariation className={className} isActive={isActive}>
      {(() => {
        switch (sys?.contentType?.sys?.id) {
          // Headers
          case 'affiliateHeader':
            return <AffiliateHeader {...fields} />;

          case 'header':
            return <Header {...fields} />;

          case 'header2':
            return <Navbar {...fields} />;

          // Web Banner
          case 'webBanner':
            return <WebBanner {...fields} />;

          case 'topSpacer':
            return <TopSpacer {...fields} />;

          // Heroes
          case 'featuredBlogPost':
            return <FeaturedBlogPost {...fields} />;

          case 'fullwidthHero20':
            return <FullwidthHero {...fields} />;

          case 'homepageHero':
            return <HomepageHero {...fields} />;

          case 'overlayHero':
            return <OverlayHero {...fields} />;

          case 'performanceHero':
            return <PerformanceHero {...fields} />;

          case 'stackedHero':
            return <StackedHero {...fields} />;

          case 'textOnlyHero':
            return <TextOnlyHero {...fields} />;

          // Page Blocks
          case 'asFeaturedOn':
            return <AsFeaturedOn />;

          case 'assetWith5050Text':
            return <AssetWith5050Text {...fields} />;

          case 'badgeList':
            return <BadgeList {...fields} />;

          case 'bodyCopy':
            return <BodyCopy {...fields} />;

          case 'careersBlock':
            return <CareersBlock {...fields} />;

          case 'imageWith5050Text':
            return <ImageWith5050Text {...fields} />;

          case 'imageWith7030Text':
            return <ImageWith7030Text {...fields} />;

          case 'infoBlock':
            return <InfoBlock {...fields} />;

          case 'milestone':
            return <Milestone {...fields} />;

          case 'plansList':
            return <PlansList {...fields} />;

          case 'plansList20':
            return <CollapsiblePlansList {...fields} />;

          case 'plansTable':
            return <PlansTable {...fields} />;

          case 'pressList':
            return <PressList {...fields} />;

          case 'sectionWithCollapsibles':
            return <SectionWithCollapsibles {...fields} />;

          case 'sectionWithPagePointers':
            return <SectionWithPagePointers {...fields} />;

          case 'socialProof':
            return <SocialProof {...fields} />;

          case 'splitModule':
            return <SplitModule {...fields} />;

          case 'storytelling':
            return <Storytelling {...fields} />;

          case 'testimonialSlider':
            return <TestimonialSliderBlock {...fields} />;

          case 'videoBlock':
            return <VideoBlock {...fields} />;

          case 'videoBlockFullwidth':
            return <VideoBlockFullWidth {...fields} />;

          case 'videoWith5050Text':
            return <VideoWith5050Text {...fields} />;

          case 'table':
            return <Tables {...fields} />;

          // Split Modules
          case 'splitAssetWithText':
            return <SplitAssetWithText {...fields} />;

          case 'splitForm':
            return <SplitForm {...fields} />;

          // Footers
          case 'footer':
            return <Footer {...fields} />;

          case 'footer20':
            return <Footer2 {...fields} />;

          case 'finalCallout':
            return <FinalCallout {...fields} />;

          default:
            return null;
        }
      })()}
    </StyledVariation>
  );
}
